var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0093,
    cy: 16.7308,
    r: 15.6586,
    fill: "#EED500",
    stroke: "#EED500",
    strokeWidth: 1.84218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5139 23.7519C24.0862 23.7519 24.5502 23.2879 24.5502 22.7157C24.5502 22.1433 24.0862 21.6794 23.5139 21.6794H10.505C9.93266 21.6794 9.46875 22.1434 9.46875 22.7157C9.46875 23.2879 9.93266 23.7519 10.505 23.7519H23.5139Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8225 13.507C12.967 13.507 13.8949 12.5791 13.8949 11.4345C13.8949 10.2899 12.967 9.36206 11.8225 9.36206C10.6779 9.36206 9.75 10.2899 9.75 11.4345C9.75 12.5791 10.6779 13.507 11.8225 13.507Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1896 13.507C23.3342 13.507 24.2621 12.5791 24.2621 11.4345C24.2621 10.2899 23.3342 9.36206 22.1896 9.36206C21.0451 9.36206 20.1172 10.2899 20.1172 11.4345C20.1172 12.5791 21.0451 13.507 22.1896 13.507Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageDark);
export default __webpack_public_path__ + "static/media/averageDark.d90afbd077a525d23512f999d4b2e62a.svg";
export { ForwardRef as ReactComponent };